import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import IntroSequence from './components/IntroSequence';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Biography from './components/Biography';
import Experience from './components/Experience';
import PracticeAreas from './components/PracticeAreas';
import WritingSamples from './components/WritingSamples';
import Credentials from './components/Credentials';
import Organizations from './components/Organizations';
import Footer from './components/Footer';
import ResumeModal from './components/ResumeModal';
import ContactPage from './pages/ContactPage';
import RetainRPage from './pages/RetainRPage';

const INTRO_KEY = 'kc_intro_seen';

const Home = () => {
  const location = useLocation();
  const [introDone, setIntroDone] = useState(() => sessionStorage.getItem(INTRO_KEY) === '1');
  const [resumeOpen, setResumeOpen] = useState(false);

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!introDone || !target) return;
    const tm = setTimeout(() => document.getElementById(target)?.scrollIntoView({ behavior: 'smooth' }), 120);
    return () => clearTimeout(tm);
  }, [introDone, location.state]);

  const finishIntro = () => {
    sessionStorage.setItem(INTRO_KEY, '1');
    setIntroDone(true);
  };

  return (
    <>
      {!introDone && <IntroSequence onFinish={finishIntro} />}
      <main>
        <Hero onQuickAccess={(kind) => { if (kind === 'resume') setResumeOpen(true); }} />
        <Biography />
        <Experience />
        <PracticeAreas />
        <WritingSamples />
        <Credentials />
        <Organizations />
      </main>
      <ResumeModal open={resumeOpen} onClose={() => setResumeOpen(false)} />
    </>
  );
};

const ScrollToTop = () => {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (!state?.scrollTo) window.scrollTo(0, 0);
  }, [pathname, state]);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/retainr" element={<RetainRPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
